window.schickHeaderSearchToggleBound = true;

$(function(){

	//scroll
	$('.scroll').click(function(){
		var speed = 700;
		var href= $(this).attr('href');
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$('html, body').animate({scrollTop:position}, speed, 'swing');
		return false;
	});

	
	//menu open
	$('#header_menu_btn').click(function(){
	if($(this).hasClass('open')){
	$('#header_menu').fadeOut(300);
	$(this).removeClass('open');
	}else{
	$('#header_search').fadeOut(50);
	$('#header_menu').fadeIn(200);	
	$(this).addClass('open');
	}
	});
	//search open
	$('#header_icon_list_item_search').click(function(){
	if($(this).hasClass('open')){
	$('#header_search').fadeOut(300);
	$(this).removeClass('open');
	}else{
	$('#header_menu').fadeOut(50);
	$('#header_menu_btn').removeClass('open');
	$('#header_search').fadeIn(200);	
	$(this).addClass('open');
	}
	});
    //search open women
	$('#header_icon_list_item_search-women').click(function(){
	if($(this).hasClass('open')){
	$('#header_search_women').fadeOut(300);
	$(this).removeClass('open');
	}else{
	$('#header_menu').fadeOut(50);
	$('#header_menu_btn').removeClass('open');
	$('#header_search_women').fadeIn(200);	
	$(this).addClass('open');
	}
	});

	$(document).ready(function(){
	header();
	$('body').addClass('show');
	});
	$(window).scroll(function(){
	header();
	});
	$(window).resize(function(){
	header();
	});
		
});

function header() {
if($('body').hasClass('template-index')){
var header = $('#header');
var top_info = $('#top_info').offset().top;
var winTop = $(this).scrollTop();

if (winTop < top_info) {
			header.removeClass('latter');
		}
		else{
			header.addClass('latter');
		}
}
}

